import { observable } from "mobx"

interface infoArgs {
  prefectures: MasterDataList
  category_map: {
    [key: number]: string
  }
  student_experience_types: MasterDataList
  student_achievement_types: MasterDataList
  industries: MasterDataList
  major_occupations: MasterDataList
  student_company_selections: MasterDataList
  regions: MasterDataList
  company_types: MasterDataList
  application_categories: MasterDataList
  unofficial_offer_status: MasterDataList
  sexes: MasterDataList
  birth_years: number[]
  birth_months: number[]
  birth_days: number[]
  school_grades: MasterDataList
  graduation_years: number[]
  days_for_work: MasterDataList
  days_for_work_in_weekday: MasterDataList
  intern_periods: MasterDataList
  experience_periods: MasterDataList
}

type MasterData = {
  id: number
  name?: string
  display?: string
  displayOrder?: number
  display_order?: number
}

type MasterDataList = MasterData[]

export class Info {
  @observable prefectures: MasterDataList
  @observable categoryMap: {
    [key: number]: string
  }
  @observable studentExperienceTypes: MasterDataList
  @observable studentAchievementTypes: MasterDataList
  @observable industries: MasterDataList
  @observable majorOccupations: MasterDataList
  @observable studentCompanySelections: MasterDataList
  @observable regions: MasterDataList
  @observable companyTypes: MasterDataList
  @observable applicationCategories: MasterDataList
  @observable unofficialOfferStatus: MasterDataList
  @observable sexes: MasterDataList
  @observable birthYears: number[]
  @observable birthMonths: number[]
  @observable birthDays: number[]
  @observable schoolGrades: MasterDataList
  @observable graduationYears: number[]
  @observable daysForWork: MasterDataList
  @observable daysForWorkInWeekday: MasterDataList
  @observable internPeriods: MasterDataList
  @observable experiencePeriods: MasterDataList

  static argListToMasterDataList(data: MasterData[]) {
    return data.map((d) => ({
      id: d.id,
      name: d.name,
      display: d.display,
      displayOrder: d.display_order,
    }))
  }

  constructor(args: infoArgs) {
    this.prefectures = Info.argListToMasterDataList(args.prefectures)
    this.categoryMap = args.category_map
    this.studentExperienceTypes = Info.argListToMasterDataList(args.student_experience_types)
    this.studentAchievementTypes = Info.argListToMasterDataList(args.student_achievement_types)
    this.industries = Info.argListToMasterDataList(args.industries)
    this.majorOccupations = Info.argListToMasterDataList(args.major_occupations)
    this.studentCompanySelections = Info.argListToMasterDataList(args.student_company_selections)
    this.regions = Info.argListToMasterDataList(args.regions)
    this.companyTypes = Info.argListToMasterDataList(args.company_types)
    this.applicationCategories = Info.argListToMasterDataList(args.application_categories)
    this.unofficialOfferStatus = Info.argListToMasterDataList(args.unofficial_offer_status)
    this.sexes = Info.argListToMasterDataList(args.sexes)
    this.birthYears = args.birth_years
    this.birthMonths = args.birth_months
    this.birthDays = args.birth_days
    this.schoolGrades = Info.argListToMasterDataList(args.school_grades)
    this.graduationYears = args.graduation_years
    this.daysForWork = Info.argListToMasterDataList(args.days_for_work)
    this.daysForWorkInWeekday = Info.argListToMasterDataList(args.days_for_work_in_weekday)
    this.internPeriods = Info.argListToMasterDataList(args.intern_periods)
    this.experiencePeriods = Info.argListToMasterDataList(args.experience_periods)
  }
}
